import { useLocale } from "./locale";
import { reverseChargeAvailable, subscriptionTaxLabel } from "./money";

/** What tax an operator pays on top of the published NestPlot price, said out
 *  loud. Our Stripe Tax behaviour is EXCLUSIVE — tax is added to the price,
 *  the B2B norm since a VAT-registered operator reclaims it — which means a UK
 *  operator reading "£99/mo" is charged more at checkout. The pricing page
 *  promises no hidden fees, so this sits next to the prices, not in a footer.
 *
 *  For EUR/GBP the reverse-charge half is the more useful: a VAT-registered
 *  business pays the published price and no VAT at all.
 */
export function TaxNote({
  currency = "USD",
  className = "",
}: {
  currency?: string;
  className?: string;
}) {
  const { t } = useLocale();
  const label = subscriptionTaxLabel(currency);
  const reverse = reverseChargeAvailable(currency);
  return (
    <div className={`text-sub text-sm leading-relaxed ${className}`}>
      {t("tax.note", { label })}
      {reverse && <> {t("tax.reverseCharge", { label })}</>}
    </div>
  );
}
